import { Actions, createNamespace } from "../../../flux/Actions";

const ns = createNamespace('SelectedActions');
export const names = {
    TOGGLE_ITEM: ns('TOGGLE_ITEM'),
    TOGGLE_ALL: ns('TOGGLE_ALL'),
    SELECT_ALL: ns('SELECT_ALL'),
};

export class SelectedItemsActions extends Actions
{
    toggleItem = (id: string | number, meta: any) => this.dispatch(names.TOGGLE_ITEM, id, meta);
    toggleAll = (meta: any) => this.dispatch(names.TOGGLE_ALL, null, meta);
    selectAll = (meta: any) => this.dispatch(names.SELECT_ALL, null, meta);
}


// WEBPACK FOOTER //
// ./src/app/flux/Grid/SelectedItemsActions.ts